import React from "react";
import "./MapSection.scss";

const MapSection = () => {
    return (
        <section className="map-section">
            <div className="map-wrapper">
                <div className="map-glow"></div> {/* Blue flowing glow behind */}
                <div className="map-container">
                    <div className="map-inner">
                        <iframe
                            title="Company Location - Lang'ata, Nairobi"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.844678703357!2d36.76135207496761!3d-1.3512374356720162!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f1a19c9c0a8df%3A0x86b53098a43e0a37!2sLang%E2%80%99ata%2C%20Nairobi%2C%20Kenya!5e0!3m2!1sen!2ske!4v1730283725826!5m2!1sen!2ske"
                            loading="lazy"
                            allowFullScreen
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MapSection;
